module.exports = __webpack_public_path__ + "img/bandcamp.105895de.png";